/**
 * Color swatches component for collection
 */

const swatches = document.querySelectorAll('.color-swatch-collection');
const container = document.querySelector('.color-swatches-collection');
const slider = document.querySelector('gridy-slider#color-swatch-collection-slider');
const containerSlider = slider.querySelector('.gridy-track');

if (swatches.length > 1) {
  // we clone and sort because we can't sort them using the css
  // order property which only sorts visible items
  const clonedSwatches = [...swatches]
    .map((swatch) => swatch.cloneNode(true))
    .sort((a, b) => {
      const aOut = a.classList.contains('color-swatch-collection--out-of-stock');
      const bOut = b.classList.contains('color-swatch-collection--out-of-stock');
      if (aOut !== bOut) return aOut ? 1 : -1;

      const aSelected = a.classList.contains('color-swatch-collection--selected');
      const bSelected = b.classList.contains('color-swatch-collection--selected');
      if (aSelected !== bSelected) return aSelected ? -1 : 1;

      return 0;
    });

  // Remove existing swatches
  containerSlider.innerHTML = '';

  // Append sorted swatches
  clonedSwatches.forEach((swatch) => {
    containerSlider.appendChild(swatch);
  });

  // Rebuild GridySlider’s internal state, otherwise arrows does not work
  if (slider && typeof slider.rebuild === 'function') {
    slider.rebuild(); // If a rebuild method exists
  } else {
    // Else, simulate it manually
    slider.slides = [...containerSlider.children];
    slider.setActiveSlide(slider.slides[0]);
  }
}

function gridyArrowSwipeVisibility() {
  const leftArrow = slider.querySelector('[data-direction="prev"]');
  const rightArrow = slider.querySelector('[data-direction="next"]');

  // Always show arrows when multiple swatches exist
  if (swatches.length > 1) {
    leftArrow?.classList.remove('hide');
    rightArrow?.classList.remove('hide');
  }
}
gridyArrowSwipeVisibility();

setTimeout(() => {
  container.classList.remove('color-swatches-collection-container-preinit');
}, 100);

// Handle update color swatch urls when variant changes
function handleSwatchCollectionUrlUpdate() {
  if (document.querySelector('variant-radios') === null) {
    // when variant radios are missing, no need to do anything
    return;
  }

  const productForm = document.querySelector('product-form');

  if (productForm === null) {
    console.error('Product form is missing');
    return;
  }

  productForm.addEventListener('change', function () {
    const searchParams = new URLSearchParams(window.location.search);
    const currentVariantId = searchParams.get('variant');

    if (!currentVariantId) {
      console.error('Current variant is missing');
      return;
    }

    const currentVariant = currentVariants.find(
      (variant) => variant.id == currentVariantId,
    );
    const { title: currentVariantTitle } = currentVariant;

    document.querySelectorAll('.color-swatch-collection').forEach((swatch) => {
      const swatchLink = swatch.querySelector('.color-swatch-collection-link');
      if (!swatchLink) {
        // no need to do anything if swatch link is missing
        return;
      }
      const swatchUrl = new URL(swatchLink.href);
      let swatchTitles;
      let swatchVariantIds;
      let swatchAvailable;

      if (
        !swatch.dataset.variantTitles ||
        !swatch.dataset.variantIds ||
        !swatch.dataset.variantAvailable
      ) {
        console.error('Swatch data is missing');
        return;
      }

      try {
        swatchTitles = JSON.parse(swatch.dataset.variantTitles);
        swatchVariantIds = JSON.parse(swatch.dataset.variantIds);
        swatchAvailable = JSON.parse(swatch.dataset.variantAvailable);
      } catch (error) {
        console.error('Error parsing swatch data');
        return;
      }

      const cleanSwatchTitles = swatchTitles
        .map((title) => title.split(' / ')[0])
        .map((title) => title.toLowerCase());
      const cleanCurrentVariantTitle = currentVariantTitle
        .split(' / ')[0]
        .toLowerCase();

      const matchedTitleIndex = cleanSwatchTitles.indexOf(
        cleanCurrentVariantTitle,
      );
      const matchedVariantId = swatchVariantIds[matchedTitleIndex] ?? null;
      const matchedVariantAvailable =
        swatchAvailable[matchedTitleIndex] ?? false;

      if (matchedVariantId !== null && matchedVariantAvailable) {
        swatchUrl.searchParams.set('variant', matchedVariantId);
        swatchLink.href = swatchUrl.toString();
      }
    });
  });
}

handleSwatchCollectionUrlUpdate();

document.addEventListener('DOMContentLoaded', () => {
  const labelEl = document.getElementById('color-swatch-current-label');
  const sliderEl = document.getElementById('color-swatch-collection-slider');
  if (!labelEl || !sliderEl) return;

  const swatches = sliderEl.querySelectorAll('.color-swatch-collection');
  if (!swatches.length) return;

  const defaultLabel =
    sliderEl.querySelector('.color-swatch-collection--selected')?.dataset?.swatchLabel ||
    labelEl.textContent.trim() ||
    swatches[0]?.dataset?.swatchLabel || '';

  const setLabel = (text) => {
    if (!text || labelEl.textContent.trim() === text) return;

    const onFadeOut = () => {
      labelEl.removeEventListener('transitionend', onFadeOut);
      labelEl.textContent = text;
      labelEl.classList.remove('is-fading');
    };

    labelEl.addEventListener('transitionend', onFadeOut);
    labelEl.classList.add('is-fading');
  };

  labelEl.textContent = defaultLabel;

  swatches.forEach((swatch) => {
    const label = swatch.dataset.swatchLabel;
    if (!label) return;

    swatch.addEventListener('mouseenter', () => setLabel(label));

    swatch.addEventListener('focusin', () => setLabel(label));

    swatch.addEventListener('mouseleave', () => setLabel(defaultLabel));
    swatch.addEventListener('focusout', (e) => {
      if (!swatch.contains(e.relatedTarget)) setLabel(defaultLabel);
    });
  });

  sliderEl.addEventListener('mouseleave', () => setLabel(defaultLabel));

  sliderEl.addEventListener('focusout', (e) => {
    if (!sliderEl.contains(e.relatedTarget)) setLabel(defaultLabel);
  });
});